/**
 * Fetches conversions via window.pear.bulkConverter.listConversions and returns
 * the count of those with status 'queued' or 'processing' (incomplete).
 * Used to show "Creating test questions from your documents" bar on my content page.
 */
export async function fetchIncompleteConversionsCount() {
  const listConversions = window?.pear?.bulkConverter?.listConversions
  if (!listConversions) {
    return { count: 0 }
  }
  try {
    const result = await listConversions({
      productType: 'EDULASTIC',
      statuses: ['queued', 'processing'],
    })
    const conversions = result?.conversions ?? []

    return { count: conversions.length }
  } catch {
    return { count: 0 }
  }
}

/** Initial interval for exponential backoff when polling converter status (ms). */
export const INCOMPLETE_CONVERSIONS_POLL_INITIAL_MS = 5000
/** Max interval for exponential backoff (ms). Sequence: 5s → 10s → 20s → 30s → 30s → … */
export const INCOMPLETE_CONVERSIONS_POLL_MAX_MS = 30000
